// ============================================================================
// File: src/modules/ppe/pages/procurement/dashboard/components/charts/FulfillmentDonut.jsx
// Purpose:
//   PO vs GRN Fulfillment Status (Enterprise Radial Progress Donut)
// ============================================================================

import React from "react";
import {
  ResponsiveContainer,
  PieChart,
  Pie
} from "recharts";

export default function FulfillmentDonut({ data }) {

  if (!data) return null;

  // ---------------------------------------------------------------------------
  // DATA
  // ---------------------------------------------------------------------------
  const completion = Number(data.completion_percent || 0);

  // ---------------------------------------------------------------------------
  // COLOR LOGIC (Semantic Status Coloring)
  // ---------------------------------------------------------------------------
  let progressColor = "#4f7cff"; // default blue

  if (completion < 40) progressColor = "#ff8a00";     // warning (orange)
  else if (completion >= 75) progressColor = "#2fbf71"; // good (green)

  // ---------------------------------------------------------------------------
  // ANGLE CALCULATION (Radial Progress)
  // ---------------------------------------------------------------------------
  const endAngle = 90 - (completion / 100) * 360;

  // ---------------------------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------------------------
  return (
    <div className="chart-card">
      <h3>PO Fulfillment Status</h3>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>

          {/* Background Ring */}
          <Pie
            data={[{ value: 100 }]}
            dataKey="value"
            innerRadius={70}
            outerRadius={95}
            fill="#e5e7eb"
            stroke="none"
            isAnimationActive={false}
          />

          {/* Progress Arc */}
          <Pie
            data={[{ value: completion }]}
            dataKey="value"
            innerRadius={70}
            outerRadius={95}
            startAngle={90}
            endAngle={endAngle}
            cornerRadius={10}
            fill={progressColor}
            stroke="none"
            animationDuration={900}
          />

          {/* CENTER LABEL */}
          <text
            x="50%"
            y="48%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="24"
            fontWeight="700"
            fill="#111827"
          >
            {completion.toFixed(1)}%
          </text>

          <text
            x="50%"
            y="60%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="12"
            fill="#6b7280"
          >
            Completed
          </text>

        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
